import { get } from "lodash";
import serverCall from "../serverCall";

const getJobs = async (params = {}) => {
  try {
    const { page = 1, limit = 10, ...otherParams } = params;

    const queryParams = {
      page: page.toString(),
      limit: limit.toString(),
      ...otherParams,
    };

    const response = await serverCall.get(`admin/job`, {
      params: queryParams,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getJobById = async (jobId) => {
  try {
    const response = await serverCall.get(`admin/job/${jobId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const createJob = async (jobData) => {
  try {
    const response = await serverCall.post(`admin/job`, jobData);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateJob = async (jobId, jobData) => {
  try {
    const response = await serverCall.put(`admin/job/${jobId}`, jobData);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteJob = async (jobId) => {
  try {
    const response = await serverCall.delete(`admin/job/${jobId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getJobReport = async (params = {}) => {
  try {
    const { page = 1, limit = 10, ...otherParams } = params;

    const queryParams = {
      page: page.toString(),
      limit: limit.toString(),
      ...otherParams,
    };

    const response = await serverCall.get(`admin/job/reports`, {
      params: queryParams,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const JobsService = {
  getJobs,
  getJobById,
  createJob,
  updateJob,
  deleteJob,
  getJobReport,
};

export default JobsService;
